import React from "react";
import { useSelector } from "react-redux";

const Banner = ({ title, text,parent, setOpen }) => {
  const { userInfo } = useSelector((state) => state?.authSlice);

  return (
    <div className="site-banner">
      <h1>{title}</h1>
      <p>{text}</p>
      {parent === 'blogs' &&
      (userInfo?.user?.role === "admin" ||
                  userInfo?.user?.role === "medicalstaff") && (
                  <button
                    onClick={() => setOpen(true)}
                    className="primary-button w-max"
                  >
                    Post new blog
                  </button>
                )}
    </div>
  );
};

export default Banner;
